import "./App.css";
import { useAuth } from "./hooks/AuthContext";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  const { appRoutes } = useAuth();

  return (
    <Router>
      <div className="App relative container">
        <Routes>
          {appRoutes.map((router, index) => {
            const Layout = router.layout;
            const Page = router.component;
            return (
              <Route
                key={index}
                path={router.path}
                element={
                  router?.protected ? (
                    <ProtectedRoute>
                      <Layout>
                        <Page />
                      </Layout>
                    </ProtectedRoute>
                  ) : (
                    <Layout>
                      <Page />
                    </Layout>
                  )
                }
              />
            );
          })}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
